/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_NameInputs */

const en_brand_name = /** @type {(inputs: Brand_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ollio Apartments`)
};

/**
* | output |
* | --- |
* | "Ollio Apartments" |
*
* @param {Brand_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const brand_name = /** @type {((inputs?: Brand_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_brand_name(inputs)
});